import { Box, styled } from '@mui/material'
import { useVirtualizer } from '@tanstack/react-virtual'
import { FC, ReactElement, useRef } from 'react'

const Container = styled(Box)`
  height: 100%;
  overflow-y: auto;
`

const ApeironRecycleList: FC<Props> = props => {
  const { estimatedHeight = 200, total, onRenderItem } = props

  const parentRef = useRef<HTMLDivElement>(null)

  const virtualizer = useVirtualizer({
    count: total,
    getScrollElement: () => parentRef.current,
    estimateSize: () => estimatedHeight
  })

  const items = virtualizer.getVirtualItems()

  return (
    <Container ref={parentRef}>
      <Box
        style={{
          height: virtualizer.getTotalSize(),
          width: '100%',
          position: 'relative'
        }}
      >
        <Box
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            transform: `translateY(${items[0]?.start ?? 0}px)`
          }}
        >
          {items.map(virtualRow => (
            <Box
              key={virtualRow.key}
              data-index={virtualRow.index}
              ref={virtualizer.measureElement}
            >
              {onRenderItem(virtualizer.measureElement, virtualRow.index)}
            </Box>
          ))}
        </Box>
      </Box>
    </Container>
  )
}

type Props = {
  estimatedHeight?: number
  total: number
  onRenderItem: (
    measureRef: (ref: Element | null) => void,
    index: number
  ) => ReactElement
}

export default ApeironRecycleList
